export const columnCode = {
    1: 'brand',
    2: 'sub_brand',
    3: 'model',
    4: 'color',
    5: 'plate',
    6: 'serial_number',
    7: 'vin',
};
